const Form062EN = {
    form: "Permission to Conduct Trading Operations Form",
    stepName: {
        statement: "Important Notes",
        basicInfor: "School Basic Information",
        partA: "Information on Trading Operations",
        partB: "Other Details and Declaration",
        confirmation: "Confirmation",
    },
    errorMsg: {
        date: {
            afterThisDate: "Please select a date after {{targetDate}}",
        },
        float: {
            rule: "This field must be a `number` type, Maximum decimal places: 2",
        },
    },
    businessTypes: {
        "Exercise books": "Exercise books",
        "Stationery and school accessories":
            "Stationery and school accessories",
        Textbooks: "Textbooks",
        "School uniforms, badges and ties": "School uniforms, badges and ties",
        "Physical education kits": "Physical education kits",
        "Lunch boxes": "Lunch boxes",
        "School bus service": "School bus service",
        "School Tuckshop": "School tuckshop",
        Newspaper: "Newspaper",
        Others: "Others",
    },
    itemTypes: {
        "Exercise books": "(1)",
        "Stationery and school accessories": "(2)",
        Textbooks: "(3)",
        "School uniforms, badges and ties": "(4)",
        "Physical education kits": "(5)",
        "Lunch boxes": "(6)",
        "School bus service": "(7)",
        "School Tuckshop": "(8)",
        Newspaper: "(9)",
        Others: "(10)",
    },
    CSDOTypes: {
        "CW&S": "Central & Western & Southern District",
        HKE: "Hong Kong East District",
        "WCH&I": "Wan Chai & Islands District",
        KC: "Kowloon City District",
        KT: "Kwun Tong District",
        SK: "Sai Kung District",
        SSP: "Sham Shui Po District",
        WTS: "Wong Tai Sin District",
        YTM: "Yau Tsim & Mong Kok District",
        N: "NORTH District",
        ST: "Sha Tin District",
        TP: "Tai Po District",
        "TW&KwT": "Tsuen Wan & Kwai Chung & Tsing Yi District",
        TM: "Tuen Mun District",
        YL: "Yuen Long District",
    },
    label: {
        committees:
            "Applicable to Schools Managed by School Management Committees",
        business: "Type of Business and Name of Supplier/Contractor",
        otherDetails: "Other Details",
        schoolName: "School Name",
        schoolAddress: "School Address",
        CSDO: "Chief School Development Officer",
        effectDate:
            "My school would like to apply for permission to conduct/enter into the following business or trading undertaking/arrangement with effect from (date)",
        businessType: "Type of Business / Trading Undertaking / Arrangement",
        supplierName: "Name of Supplier / Contractor",

        approvalSubHeading: "School Management Committee’s Approval",
        referenceNo: "School Management Committee’s Approval Reference No.",
        approvalDate: "School Management Committee’s Date of Approval",

        // referenceNo: "SMC's Approval (School's reference no.)",
        // approvalDate: "SMC's Approval (date of approval)",
        // itemNo: "Item No.",
        itemNo: "Type of Business / Trading Undertaking / Arrangement",
        rental: "Rental",
        utilitiesCharges: "Utility Charges (such as water, gas, electricity)",
        commencementDate: "Commencement Date",
        terminationDate: "Termination Date",
        documents: "Supporting Documents (if any)",
        operationValue: "Justifications",
        HKD: "HKD",
        specific: "please specify",
        statement: "Declaration (Please put a “√” in the appropriate box.)",
        statementTwo: "Declaration",
        certify: " I have read and understood the above terms and conditions.",
        rentalNote:
            "Please specify the amount per month or per annum as appropriate.",
        utilitiesNote:
            "Please indicate the amount to be paid/reimbursed by the supplier/contractor on the basis of actual consumption or at a fixed sum per month/annum as appropriate.",
        itemNoNote: "The same item no. used under (A) above should be adopted.",
        agreement: "Agreement with supplier/contractor",
        basicInfo: "School Basic Information",
    },
    statementValue: {
        statement1:
            "Regarding our application for conducting/entering into the above business or trading undertaking/arrangement, I confirm that our school will observe the requirements laid down in the prevailing Education Bureau circular on Trading Operations in Schools and will ensure that the trading operation(s) will be conducted in an open, fair and transparent manner. I further confirm that the profits/net income arising will be used for purposes <u>directly benefiting the students</u>.",
        statement2:
            "Regarding our application for conducting/entering into the above business or trading undertaking/arrangement, our school will adopt arrangement(s) not following the requirements laid down in the prevailing Education Bureau circular on Trading Operations in Schools. Details and justifications are given as follows –",
    },
    importantNotes: {
        note1: "Please submit either e-form or paper, if duplicate application has been submitted, the process would be decelerated. ",
        note2: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections,should be made in writing to the respective Senior School Development Officer.",
    },
    note: {
        note: "Please read the following terms and conditions before using this website.",
        noteList: [
            {
                text: "This online application form of permission to conduct trading operations is applicable to schools managed by School Management Committees only.",
            },
            {
                text: "Schools should refer to the prevailing Education Bureau Circular on Trading Operations in Schools before completing this form.",
            },
            {
                text: 'Supervisors should use "iAM Smart+" digital signature for endorsement.',
            },
            {
                text: "Please submit either e-form or paper form. If duplicate applications have been submitted, the application process may be affected.",
            },
        ],
    },
};
export default Form062EN;
